import testUser from '../../mocks/testUser';
import {
  showReportEngagement,
  showReportViewership,
  showReportAnticipation,
  showReportAffinity,
  showSummaryReport
} from '../../config/filters';

const showsConfig = {
  testUser,
  commentFeedQuery: {
    id: 'commentFeed',
    fields: [
      'show',
      'season',
      'episode',
      'country',
      'date',
      'age',
      'gender',
      'language'
    ]
  },
  SHOW_REPORT_FILTERS: {
    showReportEngagement,
    showReportViewership,
    showReportAnticipation,
    showReportAffinity,
    memeListQuery: {
      id: 'memesList',
      fields: ['screencapId']
    }
    // commentFeedQuery: {
    //   id: 'commentFeed',
    //   fields: [
    //     'show',
    //     'season',
    //     'episode',
    //     'country',
    //     'date',
    //     'age',
    //     'gender',
    //     'language'
    //   ]
    // }
  },
  SHOW_PAGE_ID: 'showReport',
  SHOW_ANTICIPATION_PAGE_ID: 'showReportAnticipation',
  SHOW_VIEWERSHIP_PAGE_ID: 'showReportViewership',
  SHOW_ENGAGEMENT_PAGE_ID: 'showReportEngagement',
  SHOW_AFFINITY_PAGE_ID: 'showReportAffinity',
  SHOW_SUMMARY_PAGE_ID: 'showSummaryReport',
  SHOW_SUMMARY_FILTERS: showSummaryReport
};

export default showsConfig;
